import MapleStory from 'maplestory/dist/bundle'

const instance = new MapleStory({
  Endpoint: 'https://store.maplestory.io/api'
})
export default instance
